export const LogoMark = ({ className = "h-10 w-10", inverted = false }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <rect x="4" y="10" width="30" height="28" rx="8" fill={inverted ? "#FBF6F1" : "#7938EA"} />
    <circle cx="13" cy="24" r="3.2" fill={inverted ? "#5E21C4" : "#FBF6F1"} />
    <path d="M20 18c3.4 3.4 3.4 8.6 0 12" stroke={inverted ? "#5E21C4" : "#FBF6F1"} strokeWidth="2.6" strokeLinecap="round" />
    <path d="M25.5 14.5c5.6 5.6 5.6 13.9 0 19.5" stroke={inverted ? "#D398F8" : "#FFBE98"} strokeWidth="2.6" strokeLinecap="round" opacity="0.9" />
    <path d="M31 10.5c7.8 7.8 7.8 19.2 0 27" stroke="#FF6131" strokeWidth="2.6" strokeLinecap="round" opacity="0.9" />
  </svg>
);

export const Wordmark = ({ light = false }) => (
  <span className="flex items-baseline gap-2">
    <span className={`font-display text-2xl font-extrabold tracking-tight ${light ? "text-cream" : "text-ink"}`}>
      itminane<span className="text-terra">.</span>
    </span>
    <span className={`font-ar text-base font-bold ${light ? "text-cream/70" : "text-inksoft"}`}>اطمئنان</span>
  </span>
);
